module.exports = __webpack_public_path__ + "img/ios.dcd4ccd6.png";